'use strict';

require('fancybox');
require('./PublicationCollabrationService.js');



PublicationCollabrationCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$filter',
  'publication',
  'CompanyPublicationFileService',
  'PublicationCollabrationService',
  'growl',
  'translations',
  'UploadTracker',
  'config'
];
function PublicationCollabrationCtrl(
  $scope,
  $stateParams,
  $filter,
  publication,
  CompanyPublicationFileService,
  PublicationCollabrationService,
  growl,
  translations,
  uploadTracker,
  config) {
  $scope.companyId = publication.company.id;
  $scope.publication = publication;

  function openAdditionalOptions() {
    $scope.additionalOptionsOpen = true;
  }
  
  $scope.closeAdditionalOptions = function() {
    $scope.additionalOptionsOpen = false;
  };
  
  $scope.toggleAdditionalOptions = function() {
    if($scope.additionalOptionsOpen) {
      $scope.closeAdditionalOptions();
    }
    else {
      openAdditionalOptions();
    }
  };

  $scope.uploadFilesForPublication = function(files, publicationId) {
    return uploadTracker(files.map(function(f) {
      return {
        url:  config.apiBase + "/companies/" + $scope.companyId + "/publications/" + publicationId + "/files",
        file: f,
      };
    }));
  };

  $scope.onFileSelect = function($files) {
      $scope.uploadFilesForPublication($files, $stateParams.publicationId).then(function(files) {
        publication.versionNumber += files.length;
          $scope.showVersionsTab = publication.versionNumber > 1;
        $scope.$broadcast("collabration-uploaded");
      });
  };

  $scope.openPreview = function(file, publicationId) {
    PublicationCollabrationService.getFileToken({companyId: $scope.companyId, publicationId: publicationId, fileId: file.id}, {}, function(response) {
      if (['UNSUPPORTED', 'FAILED'].indexOf(file.previewStatus) > -1) {
        return $scope.download(file, publicationId);
      }

      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
      var url = config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token;

      var type;
      switch(file.mimeType) {
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
        case 'image/bmp':
        case 'image/svg+xml':
        case 'image/webp':
          type = 'image';
          break;
        case 'application/pdf':
          if (true === iOS) {
            window.open(url, '_self');
            return;
          }
          type = 'iframe';
          break;
        default:
          type = 'iframe';
      }

      jQuery.fancybox.open([{
        type: type,
        padding: 0,
        margin: 0,
        href: url
      }]);
    });

    return false;
  };

  $scope.download = function(file, publicationId) {
    PublicationCollabrationService.getFileToken({companyId: $scope.companyId, publicationId: publicationId, fileId: file.id}, {}, function(response) {
      var additionParams = "";
      var elm = angular.element(document.querySelector('body'));
      var iFrame = elm.find('#downloadWindow');
      if (!(iFrame && iFrame.length > 0)) {
        iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
        elm.append(iFrame);
      }
      
      iFrame.attr('src', config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token + '&download=true' + additionParams);
      
      var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
      if (true === iOS) {
        window.open(config.apiBase + '/companies/' + $scope.companyId + '/publications/' + publicationId + '/files/' + file.id + '/raw?token=' + response.token + '&download=true' + additionParams, '_self');
        return;
      }
    });
  };

  $scope.rotateImage = function(file) {
    var params = {
      companyId: $scope.companyId,
      publicationId: $stateParams.publicationId,
      fileId: file.id,
      manipulate: 'rotate',
      rotate:     -90
    };
    CompanyPublicationFileService.rotateImage(params, {}).$promise.then(function(){
      $scope.$broadcast("files-uploaded");
    });
  };

}

PublicationCollabrationCtrl.resolve = {
  publication: ['$stateParams', 'PublicationCollabrationService', function($stateParams, PublicationCollabrationService) {
    return PublicationCollabrationService.get({publicationId: $stateParams.publicationId}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.file-upload-locked',
      'publication.lock-file-upload-success',
      'publication.lock-file-upload-failure'
    ]);
  }]
};
module.exports = PublicationCollabrationCtrl;

angular.module('dokiv')
  .controller('PublicationCollabrationCtrl', PublicationCollabrationCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/publication-collabrations/PublicationCollabrationCtrl.js
// module id = 430
// module chunks = 0